import { render, staticRenderFns } from "./goodsDetailDialog.vue?vue&type=template&id=3df563a3&scoped=true"
import script from "./goodsDetailDialog.vue?vue&type=script&lang=js"
export * from "./goodsDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsDetailDialog.vue?vue&type=style&index=0&id=3df563a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df563a3",
  null
  
)

export default component.exports